/**
 * Requests camera permission on first launch
 * Renders children; prompts for camera when status is denied (iOS/Android)
 */

import React, { useEffect, useRef } from 'react';
import { useCameraPermission } from '../hooks';

type Props = {
  children: React.ReactNode;
};

export function CameraPermissionRequest({ children }: Props) {
  const { requestPermission, isRequestable } = useCameraPermission();
  const hasRequested = useRef(false);

  useEffect(() => {
    if (isRequestable && !hasRequested.current) {
      hasRequested.current = true;
      requestPermission();
    }
  }, [isRequestable, requestPermission]);

  return <>{children}</>;
}
